import { AppDispatch, RootState } from '..';
import { getCustomersSuccess, onAddingCustomer, onLoadingCustomers, onUpdatingCustomer } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { companyCustomerType } from '../../types';
import { notification } from '../../utils';

const headers = (token: string) => ({
    headers: {
        authorization: `Bearer ${token}`
    }
});

export const fetchCustomers = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onLoadingCustomers(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/customers/company/${company?.company_id}`, headers(token));
    
    const { customers } = data;

    try {
        const _customers = customers?.reverse();
        dispatch(getCustomersSuccess(_customers));
        dispatch(onLoadingCustomers(false));
        
    } catch (error) {
        dispatch(onLoadingCustomers(false));
    }
};

export const addCustomer = (values: companyCustomerType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingCustomer(true));
    
    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const company_id = company?.company_id;
    const company_name = company?.name;
    const company_img_url = company?.img_url;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/customer/add`, {...values, company_id, company_name, company_img_url}, headers(token));

    const { success, message, error } = data;

    try {
        dispatch(onAddingCustomer(false));
        notification(success ? 'success' : 'error', message);
        // dispatch(fetchCustomers());
        
    } catch (err) {
        dispatch(onAddingCustomer(false));
        notification('error', error);
        console.log(error);
    }
};

export const updateCustomer = (customer: companyCustomerType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingCustomer(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/customer/${customer?.customer_id}/update`, {...customer}, headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCustomers());
        dispatch(onUpdatingCustomer(false));
        
    } catch (err: any) {

        console.log(error || err.message);
        notification('error', message);
        dispatch(onUpdatingCustomer(false));
        
    }
}; 

export const deleteCustomer = (id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/customer/${id}/delete`,  headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchCustomers());
        
    } catch (err) {
        console.log(error || err);
        notification('error', message);
    }
};